import * as z from 'zod'
import { Option, OptionEnum } from '~/shared/config/constants'
import {
  TransactionBalanceTypeEnum,
  TransactionPaymentTypeEnum,
} from '~/shared/config/enums'
import { enumOptionSchema, uuidOptionSchema } from '~/shared/lib/schemas'

export const formSchema = z.object({
  flowStatementId: uuidOptionSchema,
  paymentType: enumOptionSchema(TransactionPaymentTypeEnum),
  balanceType: enumOptionSchema(TransactionBalanceTypeEnum)
    .optional()
    .nullable(),
})
export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = Omit<
  TypeFormSchema,
  'flowStatementId' | 'paymentType' | 'balanceType'
> & {
  flowStatementId: UniqueId | Option
  paymentType:
    | OptionEnum<TransactionPaymentTypeEnum>
    | TransactionPaymentTypeEnum
  balanceType:
    | OptionEnum<TransactionBalanceTypeEnum>
    | TransactionBalanceTypeEnum
    | null
}
